import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../../app.service';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { generalConfigFromGlobal } from '../../shared/workspace-element-context';
import { ScreenDocumentList } from '../screen-document-upload/screen-document';
import { ScreenDocumentService } from '../screen-document-upload/screen-document.service';
import { DocumentViewDialogComponent } from './document-view-dialog/document-view-dialog.component';

@Component({
    selector: 'gtw-screen-document-list',
    templateUrl: './screen-document-list.component.html',
    styleUrls: ['./screen-document-list.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ScreenDocumentListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  isLoading = false;
  durationInSeconds = 5;

  @Output()
  documentUrl = new EventEmitter<boolean>();

  @Output()
  updateDocSelectedEvent = new EventEmitter();

  @Output()
  deleteDocSelectedEvent = new EventEmitter();

  attachmentList: any = [];
  @Input('refresh')
  set refresh(value: boolean) {
    if (value) {
      this.getAllDocuments();
    }
  }

  constructor(
    public gtwGlobal: GlobalService,
    public gtwWorkspace: WorkspaceService,
    public gtwApp: AppService,
    private screenDocumentService: ScreenDocumentService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    if (!isNaN(this.clientKeyNum) && !isNaN(this.screenKeyNum)) {
      this.getAllDocuments();
    }
  }

  private activeScreen(): any {
    return this.gtwWorkspace.workspaceFactory?.activeScreen || {};
  }

  private getBaseUrl(): string {
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    return String(gc.base_url ?? gc.api ?? '');
  }

  get screenKeyNum(): number {
    const a = this.activeScreen();
    const raw = a.link ?? a.screenKey ?? a.screen_key;
    return parseInt(String(raw), 10);
  }

  get clientKeyNum(): number {
    const raw =
      this.gtwGlobal.global?.globalParams?.client_key ?? this.gtwApp.USER_SETTINGS?.user?.client_key;
    return parseInt(String(raw), 10);
  }

  getAllDocuments() {
    console.log('I am called');
    this.screenDocumentService
      .getAllDocumentsList(this.getBaseUrl(), this.clientKeyNum, this.screenKeyNum).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          if (res.callSuccess == 1 || parseInt(res.callSuccess) == 1) {
            this.attachmentList = res.data;
          } else {
          }
        },
        () => {}
      );
  }

  editDoc(updateDoc: ScreenDocumentList): void {
    this.updateDocSelectedEvent.emit(updateDoc);
  }

  deleteDoc(deleteDocKey: any): void {
    this.screenDocumentService
      .deleteDocumentById(this.getBaseUrl(), this.clientKeyNum, this.screenKeyNum, deleteDocKey).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          if (res.callSuccess == 1 || parseInt(res.callSuccess) == 1) {
            this.openSnackBar('Document Deleted Successfully !!');

            this.getAllDocuments();
          } else {
            this.openSnackBar(res.errorMessage);
          }
        },
        () => {}
      );
  }

  openDialog(selectedDoc: ScreenDocumentList) {
    const dialogRef = this.dialog.open(DocumentViewDialogComponent, {
      data: selectedDoc,
    });

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  private openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: this.durationInSeconds * 1000,
    });
  }
}
